import React, { MouseEventHandler, ReactNode } from "react"
import { useHistory, useParams } from "react-router"

import {
  useAccount,
  useChatInfo,
  useHandleMessagesContext,
  useLayerPopupContext,
  useSetChatInfo,
} from "@shared/contexts"
import { getRequiredQuery } from "@shared/modules"
import { Params } from "@shared/types"

import LinkItem from "./LinkItem"

interface Props {
  title: string
  isChatMode: boolean
  children: ReactNode
}

const SearchBar = ({ title, children, isChatMode }: Props) => {
  const history = useHistory()
  const { scheduleId, streamerName } = useParams<Params>()
  const { isSearchBarEnabled } = useChatInfo()
  const setChatInfo = useSetChatInfo()
  const { open } = useLayerPopupContext()
  const { account } = useAccount()
  const { search } = useHandleMessagesContext()

  const isAnonymous = account?.viewer?.role === "ANONYMOUS"

  const handleSearchClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault()
    if (isAnonymous) return open("ANONYMOUS")

    if (isSearchBarEnabled) {
      history.push(
        `/${streamerName}/${scheduleId}${
          isChatMode ? "/chat-mode" : ""
        }${getRequiredQuery()}`,
      )
      search("")
    }

    setChatInfo({ type: "TOGGLE_SEARCH_BAR" })
  }

  return (
    <LinkItem
      className="ty01"
      innerClassName={isSearchBarEnabled ? "on" : ""}
      title={title}
      onClick={handleSearchClick}
    >
      {children}
    </LinkItem>
  )
}

export default SearchBar
